import {
	cilUser,
	cilLockLocked,
	cilMap,
	cilMonitor,
	cilNotes,
	cilSortAscending,
	cilSortDescending,
	cilClipboard,
	cilFilter,
	cilSitemap,
	cilViewQuilt,
	cilCalendar,
	cilPencil,
	cilPrint,
	cilViewColumn,
	cilX,
	cilTransfer,
	cilEthernet,
	cilShareBoxed,
	cilFlagAlt,
	cilTrash,
	cilFile,
	cilBarChart,
	cilVerticalAlignBottom,
	cilCheckAlt,
} from '@coreui/icons';

const icons = {
	...{
		cilUser,
		cilLockLocked,
		cilMap,
		cilMonitor,
		cilNotes,
		cilSortAscending,
		cilSortDescending,
		cilClipboard,
		cilFilter,
		cilSitemap,
		cilViewQuilt,
		cilCalendar,
		cilPencil,
		cilPrint,
		cilViewColumn,
		cilX,
		cilTransfer,
		cilEthernet,
		cilShareBoxed,
		cilFlagAlt,
		cilTrash,
		cilFile,
		cilBarChart,
		cilVerticalAlignBottom,
		cilCheckAlt,
	},
};

export default icons;
